import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { debounce } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";

import Close from "../../../assets/images/close-icon.png";

import Loader from "../../../components/Loader/Loader";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "react-circular-progressbar/dist/styles.css";
import "../../../components/common/css/datatable.scss";
import { useForm } from "react-hook-form";
import { SaveCurrency } from "../../../redux/actions/adminActions";
const CurrencyList = () => {
  let token = localStorage.getItem("accessToken");
  const dispatch = useDispatch();

  const [query, setQuery] = useState("");
  const [percentage, setPercentage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });

  const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [id, setID] = useState();
  const [currencyName, setCurrencyName] = useState();
  const [currencyRate, setCurrencyRate] = useState();
  const [getCountryId, setCountryId] = useState();

  const handleOpen = (row) => {
    setOpen(true);
    setID(row?.id);
    setCurrencyName(row?.currency_name);
    setCurrencyRate(row?.currency_rate);
    setCountryId(row?.country_id);
    // setStatus(row?.request_status);
  };

  const currencyListView = useSelector((state) => state.currencyListView);
  const { currencyList } = currencyListView;
  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  const fetchuserData = () => {
    // console.log("pageNo", pageState.page);
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "managecurrency-rates-get",
      headers: {
        "x-access-token": token,
      },

      data: {
        page: pageState.page,
        limit: pageState.pageSize,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        setPercentage(response?.data?.data?.percent);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    if (currencyList) {
      setLoading(false);
      setPageState((old) => ({
        ...old,
        data: currencyList.data.rows,
        total: currencyList.data.count,
      }));
    }
  }, [currencyList]);

  useEffect(() => {
    if (currencyList) {
      setValue("currency_value", currencyList?.data?.rows?.currency_value);
      setValue("currency_name", currencyList?.data?.rows?.currency_name);
    }
  }, [currencyList]);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    const cdata = {
      page: pageState.page,
      limit: pageState.pageSize,
    };
    dispatch(SaveCurrency(token, cdata));
    setLoading(false);
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const updateCurrencyData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "managecurrency-rates",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id,
        currency_name: currencyName,
        currency_rate: currencyRate,
        // country_id: "18.00",
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "Approve Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        setOpen(false);
        fetchuserData();

        // setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response !== "" && error.response.data.message !== "") {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };

  const requestColumn = [
    {
      field: "request",
      headerName: "Request",
      width: 160,
      renderCell: (params) => {
        return (
          <div className="cellRequest">
            <button
              // className="requestView-btn"
              onClick={() => handleOpen(params.row)}
            >
              Update Currency
            </button>

            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal-popup">
                <div className="modal-top">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Update Currency
                  </Typography>
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                  <div className="new">
                    <div className="newContainer">
                      <div
                        className="bottom"
                        style={{ boxShadow: "none", padding: "0" }}
                      >
                        <div className="right">
                          <form className="accredited-investorForm">
                            <div className="formInput">
                              <label>Currency Name</label>
                              <input
                                type="text"
                                name="currency_name"
                                style={{ textTransform: "uppercase" }}
                                maxLength={3}
                                readOnly
                                value={currencyName}
                                onChange={(e) =>
                                  setCurrencyName(e.target.value)
                                }
                                placeholder="Enter Currency Name"
                              />
                            </div>
                            <div className="formInput">
                              <label>Currency Rate</label>
                              <input
                                type="text"
                                name="currency_rate"
                                value={currencyRate}
                                placeholder="Enter Currency Rate"
                                onChange={(e) =>
                                  setCurrencyRate(e.target.value)
                                }
                              />
                            </div>

                            <div className="item accreditedItem">
                              <div className="details profile-info">
                                <div className="submitButton">
                                  <button
                                    className="approveButton"
                                    type="button"
                                    onClick={() => updateCurrencyData()}
                                  >
                                    Update
                                  </button>

                                  <button
                                    className="cancelButton"
                                    type="button"
                                    onClick={() => setOpen(false)}
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </Typography>
              </Box>
            </Modal>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "user_country",
      headerName: "Country Name",
      width: 150,
      renderCell: (params) => {
        // console.log(params);

        return <span>{params?.value?.country_name}</span>;
      },
    },
    {
      field: "currency_name",
      headerName: "Currency Name",
      width: 150,
    },
    {
      field: "currency_rate",
      headerName: "Currency Rate",
      width: 150,
    },
  ];
  useEffect(() => {
    fetchuserData();
  }, [pageState.page, pageState.pageSize, query]);

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          {/* <input type="text" placeholder="Search..." onChange={handleQuery} /> */}
          {/* <SearchOutlinedIcon className="sarchicon" /> */}
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Currency Management</h5>
        <div></div>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(requestColumn)}
      />
    </div>
  );
};

export default CurrencyList;
